// extracted by mini-css-extract-plugin
export default {"actions":"styles-module__actions__src-labstep-web-screens-Resource-Show-Center-SecondaryInfo-_vr2a2"};